<template>
  <div class="box5">
    <pageTitle title="阶梯式培养计划&nbsp;&nbsp;胜任各类岗位" />
    
    <div class="content">
      <ul>
        <li v-for="(item,index) in arr" :key="index">
            <span>
              <h1>{{item.h1}}</h1>
              <p>{{item.p}}</p> 
            </span>
             <div class="img">
               <div class="first">
                  <img :src='require("../../../assets/coursePage/linux/box5/0"+(index+1)+".png")'/>
                </div>
               <img class="last" src="../../../assets/coursePage/linux/box5/arrow.png"/>
             </div>
        </li>
        
      </ul>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle, 
  },
  data() {
    return {
     arr:[{
        "h1": "Linux云计算运维基础",
        "p": "学员能够胜任初级系统管理员或初级运维工程师岗位，负责服务器的⽇常维护、基础配置、项⽬部署等初级Linux服务器运维⼯作。"
      },
      {
        "h1": "系统运维阶段",
        "p": "学员可以胜任系统运维工程师或应用运维工程师的岗位，专注于系统服务管理、资源管理以及故障处理等⼯作。"
      },
      {
        "h1": "数据库运维阶段",
        "p": "学员可以胜任数据库运维⼯程师岗位，负责数据库管理、性能优化以及灾备方案的执⾏。"
      },
      {
        "h1": "自动化运维",
        "p": "学员能够胜任自动化运维工程师或DevOps工程师岗位，负责⾃动化运维体系的建立与优化。"
      },
      {
        "h1": "容器运维",
        "p": "学员能够胜任容器运维⼯程师岗位，负责容器化平台的⽇常维护与优化，⽀持企业微服务架构的运维需求。"
      },
      {
        "h1": "云计算+云安全运维阶段",
        "p": "学员具备云计算资源管理、监控、自动化运维及安全防护的综合能力，能够胜任云计算运维工程师等岗位。"
      },
      {
        "h1": "国产信创运维阶段",
        "p": "学员具备在信创环境中执⾏操作系统和数据库维护、优化及安全管理的能力，能够胜任军工、政府及企事业单位等信创运维岗位。"
      }
    ]
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box5 {
  background: url("../../../assets/coursePage/linux/box5/bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 60px 0 80px;
  .content{
    margin-top: 48px ;
    padding: 0 30px;
    ul{
      li{
       
        background: #FFFFFF;
        box-shadow: 0px 0px 28px 0px #EDF4FC;
        border-radius: 20px;
        padding: 24px 0 20px 40px;
        position:relative;
        box-sizing: border-box;
        margin-bottom: 30px;
        h1{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #001F3C;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          margin-bottom: 14px;
        }
        p{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #7F8B96;
          line-height: 36px;
          text-align: left;
          font-style: normal;
        }
        span{
          position: relative;
          display: block;
          width:476px;
        }
        .img{
          position: absolute;
          top:22px;
          right: 28px;
          .first{
           
            width: 148px;
            img{
               height: 124px;
              display: block;
            }
          }
           img.last{
            width: 38px;
            margin-top: 6px ;
             display: block;
             float: right;
          }
        }
      }
      li:last-child{
        margin-bottom: 0;
      }
    }
  }
}
</style>
